import { getPreferredVideoInputId } from '@streem/toolbox';
import appLogger from './logging/app_logger';

export const logPreferredVideoDevice = () => {
    const preferredVideoInputId = getPreferredVideoInputId();
    if (preferredVideoInputId) {
        appLogger.info(`Preferred video device id: ${preferredVideoInputId}`);
    } else {
        appLogger.info('Preferred video device has not been set');
    }
};
